var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import Pikaday from 'pikaday-no-moment';
import { Field } from 'redux-form';
import BEMHelper from 'react-bem-helper';
import { formatDate, parseDate, createInputDateMask } from '../../../helpers/dateHelper';
import APIcon from '../APIcon';
import isSameDay from 'date-fns/is_same_day';
import InputMask from 'react-input-mask';
import isDate from 'date-fns/is_date';
import 'pikaday-no-moment/css/pikaday.css';
import './APDatePicker.css';
var baseClasses = new BEMHelper({
  name: 'ap-datepicker',
  outputIsString: true
});
var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);
  function DatePicker(props) {
    _classCallCheck(this, DatePicker);
    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));
    _this.handleChange = function (value) {
      _this.props.input.onChange(value);
      if (_this.props.customChange) {
        _this.props.customChange(value);
      }
    };
    _this.datepickerRef = null;
    _this.inputMaskRef = null;
    _this._picker = null;
    _this.state = {
      inputMask: '',
      formatMask: ''
    };
    return _this;
  }
  _createClass(DatePicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.input.value === undefined) {
        this.inputMaskRef.value = '';
      }
      if (!isSameDay(prevProps.input.value, this.props.input.value) && (isDate(this.props.input.value) || this.props.input.value === null)) {
        this._picker.setDate(this.props.input.value);
        if (this.props.input.value === null) {
          this.inputMaskRef.value = '';
        } else {
          this.inputMaskRef.value = formatDate(this.props.input.value, this.state.formatMask);
        }
      }
      if ((isDate(this.props.minDate) || this.props.minDate === null) && !isSameDay(prevProps.minDate, this.props.minDate)) {
        this._picker.setMinDate(this.props.minDate);
      }
      if ((isDate(this.props.maxDate) || this.props.maxDate === null) && !isSameDay(prevProps.maxDate, this.props.maxDate)) {
        this._picker.setMaxDate(this.props.maxDate);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _createInputDateMask = createInputDateMask(),
        inputMask = _createInputDateMask.inputMask,
        formatMask = _createInputDateMask.formatMask;
      this.setState({
        inputMask: inputMask,
        formatMask: formatMask
      });
      var el = this.datepickerRef;
      var _props = this.props,
        customFormat = _props.customFormat,
        customParse = _props.customParse,
        minDate = _props.minDate,
        maxDate = _props.maxDate;
      this._picker = new Pikaday(Object.assign({
        field: el,
        yearRange: [1900, new Date().getFullYear()],
        format: formatMask,
        toString: customFormat,
        parse: customParse,
        minDate: minDate,
        maxDate: maxDate,
        onSelect: this.handleChange
      }, this.props.initialOptions));
      this.addClassNames();
      if (isDate(this.props.input.value)) {
        this._picker.setDate(this.props.input.value);
        this.inputMaskRef.value = formatDate(this.props.input.value, formatMask);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._picker.destroy();
      this._picker = null;
    }
  }, {
    key: 'getCustomClasses',
    value: function getCustomClasses() {
      return new BEMHelper({
        name: this.props.customClass,
        outputIsString: true
      });
    }
  }, {
    key: 'addClassNames',
    value: function addClassNames() {
      var _this2 = this;
      var customClasses = this.getCustomClasses();
      this._picker.el.classList.add(baseClasses('calendar'));
      customClasses('calendar').split(' ').forEach(function (customClass) {
        return _this2._picker.el.classList.add(customClass);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var _props2 = this.props,
        label = _props2.label,
        meta = _props2.meta,
        info = _props2.info,
        input = _props2.input,
        disabled = _props2.disabled,
        required = _props2.required,
        showIcon = _props2.showIcon,
        iconClick = _props2.iconClick;
      var onChange = input.onChange,
        _onBlur = input.onBlur,
        value = input.value,
        otherInputProps = _objectWithoutProperties(input, ['onChange', 'onBlur', 'value']);
      var customClasses = this.getCustomClasses();
      return React.createElement('div', {
        className: 'form-group ' + baseClasses('input-wrapper') + ' ' + customClasses('dpk-wrapper')
      }, React.createElement('label', {
        className: 'ap--label ' + baseClasses('label') + ' ' + customClasses('dpk-label')
      }, label), React.createElement(InputMask, Object.assign({
        ref: function ref(_ref2) {
          return _this3.inputMaskRef = _ref2;
        },
        mask: this.state.inputMask,
        placeholder: this.state.formatMask
      }, {
        disabled: disabled,
        required: required
      }, otherInputProps, {
        onChange: function onChange(e) {
          return _this3.handleChange(e.target.value);
        },
        onBlur: function onBlur(e) {
          return _onBlur(parseDate(e.target.value));
        }
      }), function (inputProps) {
        return React.createElement('input', Object.assign({
          ref: function ref(_ref) {
            return _this3.datepickerRef = _ref;
          },
          className: 'form-control ' + baseClasses('input') + ' ' + customClasses('dpk-input')
        }, inputProps, {
          autoComplete: 'off'
        }));
      }), showIcon && React.createElement('div', {
        className: baseClasses('icon-container'),
        onClick: iconClick
      }, React.createElement(APIcon, {
        name: 'calendar',
        customClass: baseClasses('icon')
      })), React.createElement('small', {
        className: 'form-text-muted ' + baseClasses('info') + '  ' + customClasses('dpk-info')
      }, info), meta.dirty && meta.error && React.createElement('span', {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
  return DatePicker;
}(React.Component);
DatePicker.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  customClass: PropTypes.string,
  // For custom format visit `toString` section of https://github.com/dbushell/Pikaday#formatting
  customFormat: PropTypes.func,
  customParse: PropTypes.func,
  info: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  initialOptions: PropTypes.object,
  showIcon: PropTypes.bool,
  iconClick: PropTypes.func
};
DatePicker.defaultProps = {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  required: false,
  initialOptions: {},
  customFormat: formatDate,
  customParse: parseDate,
  showIcon: false
};
export default function APDatePicker(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: DatePicker
  }, props));
}
export { DatePicker };